/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useSnapshot } from 'valtio';

import Filter from './filter';

import { refsStore, poiStore } from '../managers/globalState';
import { POI_CATEGORIES } from '../config/constants';
import { updateYear, updateCategory } from '../helpers/processPoI';

import '../../www/assets/css/poi_dropdowns.css';

const PoIDropdowns = () => {
	// Get the year and category index global state.
	const { yearIndex, poicategoryIndex, showOnGlobePoI } = useSnapshot(poiStore.state);
  // console.log("poi_dropdowns", yearIndex, poicategoryIndex,showOnGlobePoI)
	// Get the content manager using the global state 'get' reference.
	const { get } = useSnapshot(refsStore.state);
	const { poiYears } = get('content');

	let showSpacecraft = false;
	const router = get('route');

	if (router?._history?.location?.pathname) {
		const { pathname } = router._history.location;
		showSpacecraft = pathname.indexOf('spacecraft') >= 0;
	}

	if (showSpacecraft) {
		return null;
	}

	return (
		<div
			className={'poi-dropdowns-container' + (showOnGlobePoI ? ' poi-dropdowns-offset' : '')}
		>
			<Filter type='dropdown' allItems={poiYears} updateItem={updateYear} selectedIndex={yearIndex} />
			<Filter type='dropdown' allItems={POI_CATEGORIES} updateItem={updateCategory} selectedIndex={poicategoryIndex} minWidth='130px' />
		</div>
	);
};


export default PoIDropdowns;
